<ng-container *appMailAppContext>
<!--
  #998: mail has no top bar. The page starts at y = 0, so this wrapper is mail's own — `.under-nav-bar`
  is shared by the layouts that still carry a 48 px bar and must keep its offset for them.

  #1547: the rail's OWN split-view is gone, as notes' went in #1146. It is a fixed 266 px column now —
  no gutter, no drag, no magnetic width and no reopen chevron. The rail component owns its parked width;
  the host owns the docked one and passes it in the stylesheet.

  The MESSAGE LIST keeps its splitter, and keeps `[iconTop]="38"` with it: the split-view's own reopen
  chevron defaults to `top: -10px` from its own top edge, which from y = 0 would draw half above the window.
-->
<div class="mail-shell">
  <!--
    The shell sits OUTSIDE `*stchSpaceRerender` on purpose: the bell's subscription, the app switcher
    and the search input survive a workspace switch. Only the rail below is torn down and rebuilt.
  -->
  <app-collapsible-rail-shell class="mail-rail" [app]="app">
    <app-messages-side-bar *stchSpaceRerender />
  </app-collapsible-rail-shell>

  <app-split-view
    class="mail-rest"
    side="left"
    key="mailsList"
    [collapsedSize]="25"
    [shadow]="true"
    [magneticSize]="300"
    [withIcon]="true"
    [iconTop]="38"
  >
    <app-messages2-list-container
      split-left-pane
      *stchSpaceRerender
      class="list shadow-lg"
    />

    <div
      split-right-pane
      class="full-form shadow-lg"
    >
      <app-messages2-main-view *stchSpaceRerender />
    </div>
  </app-split-view>
</div>
</ng-container>
